import * as React from "react";
import type { SVGProps } from "react";
const SvgSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="search_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 469.333a298.667 298.667 0 1 1 597.333 0 298.667 298.667 0 0 1-597.333 0zm298.666-384a384 384 0 1 0 239.702 684.032l156.8 156.8a42.667 42.667 0 0 0 60.33-60.33l-156.8-156.8A384 384 0 0 0 469.333 85.333z"
    />
  </svg>
);
export default SvgSearchIcon;
